import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loader from "components/Loader";
import {
  Home,
  Main,
  Buy,
  OcbPw,
  HanaMain,
  HanaBuyInfo,
  HanaBuy,
  CertificationStart,
  CertificationError,
  CertificationErrorGateway,
} from "pages";
import Owp from "../components/Owp";
import Temp from "../components/Temp";
import AuthTest from "../components/AuthTest";
import SignupTest from "../components/SignupTest";
import LeaveTest from "../components/LeaveTest";
import Alert from "components/Alert";
import Link from "../components/Link";
import CommonHeader from "../components/CommonHeader";
import { useLocalStorage } from "../lib/useLocalStorage";
import { STORAGE_KEY } from "../constants";

const App = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [preServiceCode, setServiceCode] = useLocalStorage(
    STORAGE_KEY.SERVICE_CODE,
    ""
  );

  const commonRoute = (Component) => {
    return (props) => {
      const commonProps = {};

      commonProps.showLoading = (message) => {
        setLoadingMessage(message);
        setIsLoading(true);
      };

      commonProps.hideLoading = () => {
        setLoadingMessage("");
        setIsLoading(false);
      };

      const reqParamObj = new URLSearchParams(props.location.search);
      const serviceCode = reqParamObj.get("serviceCode") || "";

      if (serviceCode) {
        if (preServiceCode !== serviceCode) {
          setServiceCode(serviceCode);
        }
      }

      commonProps.serviceCode = preServiceCode;

      commonProps.isFirstLoad = isFirstLoad;
      commonProps.setIsFirstLoad = setIsFirstLoad;

      return <Component {...props} {...commonProps} />;
    };
  };

  return (
    <div>
      <Router basename={process.env.PUBLIC_URL}>
        <CommonHeader serviceCode={preServiceCode} />
        <Route exact path="/" component={Home} />
        <Switch>
          <Route path="/main" render={commonRoute(Main)} />
          <Route path="/buy" render={commonRoute(Buy)} />
          <Route path="/ocbPw" render={commonRoute(OcbPw)} />
          <Route path="/temp" render={commonRoute(Temp)} />
          <Route path="/auth" render={commonRoute(AuthTest)} />
          <Route path="/signup-test" render={commonRoute(SignupTest)} />
          <Route path="/leave-test" render={commonRoute(LeaveTest)} />
          <Route path="/owp" render={commonRoute(Owp)} />
          <Route path="/alert" render={commonRoute(Alert)} />
          <Route path="/link" render={commonRoute(Link)} />

          {/* Hana */}
          <Route path="/hana-main" render={commonRoute(HanaMain)} />
          <Route path="/hana-buy-info" render={commonRoute(HanaBuyInfo)} />
          <Route path="/hana-buy" render={commonRoute(HanaBuy)} />

          {/* Hana - 본인인증 */}
          <Route
            path="/certification/start"
            render={(props) => <CertificationStart {...props} />}
          />
          <Route
            path="/certification/error"
            component={CertificationErrorGateway}
          />
          <Route
            path="/certification/error-guide"
            component={CertificationError}
          />
        </Switch>
      </Router>
      {isLoading && <Loader message={loadingMessage} />}
    </div>
  );
};

export default App;
